import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import colors from '../../../configuration/colors'
import Modal from '../../mini/Modal'
import TrashSvg from '../../../static/images/icons/icon_trash_red_outline.svg'
import FlexAlignCenter from '../../styled/FlexAlignCenter'
import { H3, P2 } from '../../styled/typography/typography'
import useLexicon from '../../../hooks/useLexicon'

const Alert = styled.div`
  text-align: center;
  font-size: 13px;
`

export const TrashIcon = styled.img.attrs({
  src: TrashSvg
})`
  width: 24px;
  height: 29px;
`

const AlertWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  color: #000;
`

const CancelButton = styled.button`
  border: none;
  box-shadow: none !important;
  cursor: pointer;

  &:hover {
    border: none;
    box-shadow: none !important;
  }
`

const Header = styled(H3)`
  margin-top: 20px;
`

const DeleteSkillCheck = ({ onCancel, onDelete }) => {
  const lexicon = useLexicon()

  return (
    <Modal
      width={500}
      top={50}
      autoHeight
      allowOverflow
    >
      <Alert>
        <AlertWrapper>
          <div
            style={{
              padding: '20px'
            }}
          >
            <TrashIcon />
            <Header as="h3">
              Are you sure you want to delete
              <br /> this {lexicon.skill.toLowerCase()}s check?
            </Header>
            <P2 as="p">Once deleted, this cannot be undone.</P2>
          </div>
          <FlexAlignCenter
            style={{
              justifyContent: 'flex-end',
              padding: '20px',
              borderTop: `1px solid ${colors.rock}`
            }}
          >
            <CancelButton className="quest-btn btn-c" onClick={onCancel}>
              Cancel
            </CancelButton>
            <button
              className="quest-btn btn-d"
              style={{
                marginLeft: '10px',
                paddingLeft: '40px',
                paddingRight: '40px',
                cursor: 'pointer'
              }}
              onClick={onDelete}
            >
              Delete
            </button>
          </FlexAlignCenter>
        </AlertWrapper>
      </Alert>
    </Modal>
  )
}

DeleteSkillCheck.propTypes = {
  onCancel: PropTypes.func,
  onDelete: PropTypes.func
}

export default DeleteSkillCheck
